import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-loader',
  templateUrl: './progress-loader.component.html',
  styleUrls: ['./progress-loader.component.scss'],
  standalone: false
})
export class ProgressLoaderComponent {
  @Input() duration: number = 5000; // in milliseconds
  @Input() messages: string[] = [];
  
  currentMessageIndex: number = 0;
  progress: number = 0;
  message: string = '';
  isLoading: boolean = true;

  ngOnInit() {
    this.startLoading();
  }

  startLoading() {
    const stepDuration = 100; // Intervall in Millisekunden
    const totalSteps = this.duration / stepDuration;
    const breakpoints = [0.1, 0.4, 0.7, 0.8, 1]; // Zufällige Stellen, an denen der Ladebalken kurz anhält
    this.showMessage();
    
    let stepCount = 0;
    const interval = setInterval(() => {
      if (stepCount >= totalSteps) {
        clearInterval(interval);
        this.isLoading = false;
        return;
      }

      this.progress = (stepCount / totalSteps) * 100;
      if (breakpoints.includes(stepCount / totalSteps)) {
        this.showMessage();
      }

      stepCount++;
    }, stepDuration);
  }

  showMessage() {
    this.message = this.messages[this.currentMessageIndex];
    this.currentMessageIndex = (this.currentMessageIndex + 1) % this.messages.length;
  }
}